export default function EmailTemplateSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="space-y-6 max-w-3xl py-8 text-left">
        <div className="rounded-md bg-gray-50 p-4 md:p-6">
          {/* Template Name */}
          <div className="mb-4">
            <div className="h-5 w-32 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 w-full bg-gray-200 rounded"></div>
          </div>
          {/* Subject */}
          <div className="mb-4">
            <div className="h-5 w-20 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 w-full bg-gray-200 rounded"></div>
          </div>
          {/* Description */}
          <div className="mb-4">
            <div className="h-5 w-28 bg-gray-200 rounded mb-2"></div>
            <div className="h-24 w-full bg-gray-200 rounded"></div>
          </div>
          {/* Body */}
          <div className="mb-4">
            <div className="h-5 w-16 bg-gray-200 rounded mb-2"></div>
            <div className="h-48 w-full bg-gray-200 rounded"></div>
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-4">
          <div className="h-10 w-24 bg-gray-200 rounded"></div>
          <div className="h-10 w-32 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
}